import React, { useState, useCallback } from 'react';

import PropTypes from 'prop-types';
import { isEmailValid } from 'utils/validator';
import useClipboardValue from 'hooks/useClipboardValue';
import Keyboard from 'containers/Keyboard';
import { StyledBlock, StyledKeyboardWrapper } from '../StyledComponents';
import ActionsSection from '../ActionsSection';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';

const EmailForm = (props) => {
  const {
    initialValue,
    placeholder,
    invalidMessage,
    buttonLabel,
    sectionName,
    onSubmit,
    children,
    analyticsEventGroup,
    analyticsEventName,
  } = props;

  const [email, setEmail] = useState(initialValue);
  const [cursorPosition, setCursorPosition] = useState(initialValue.length);
  const [isValid, setIsValid] = useState(true);
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);

  const showKeyboard = useCallback(() => setIsKeyboardVisible(true), []);
  const hideKeyboard = useCallback(() => setIsKeyboardVisible(false), []);
  const onValueUpdate = useCallback((value) => setEmail(value), []);
  const onCursorPositionUpdate = useCallback((value) => setCursorPosition(value), []);
  const onButtonClick = useCallback(() => {
    if (isEmailValid(email)) {
      onSubmit(email);
    } else {
      innerAnalyticsVolia.postEvent({
        eventGroup: analyticsEventGroup,
        eventName: analyticsEventName,
        eventValue: `login type="email";${email.length ? '"wrong format"' : '"user id cannot be empty"'}`,
      });
      setIsValid(false);
    }
  }, [analyticsEventGroup, analyticsEventName, email, onSubmit]);

  useClipboardValue((value) => {
    if (!isEmailValid(value)) return;
    setEmail(value);
    setCursorPosition(value.length);
    setIsKeyboardVisible(false);
  });

  return (
    <StyledBlock>
      <ActionsSection sectionName={sectionName} defaultSection>
        <ActionsSection.Input
          value={email}
          cursor={isKeyboardVisible}
          cursorPosition={cursorPosition}
          placeholder={placeholder}
          isValid={!isKeyboardVisible ? isValid : true}
          invalidMessage={invalidMessage}
          onEnter={showKeyboard}
        />
        <ActionsSection.Button label={buttonLabel} onEnter={onButtonClick} />

        {children}
      </ActionsSection>
      {isKeyboardVisible && (
        <StyledKeyboardWrapper>
          <Keyboard
            onQueryUpdated={onValueUpdate}
            onCursorPositionUpdate={onCursorPositionUpdate}
            onLeave={hideKeyboard}
            query={email}
            maxQuerySize={130}
            selectedLanguage="en"
            type="email"
          />
        </StyledKeyboardWrapper>
      )}
    </StyledBlock>
  );
};

EmailForm.defaultProps = {
  sectionName: '@EMAIL_INPUT',
  initialValue: '',
};

EmailForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  initialValue: PropTypes.string,
  placeholder: PropTypes.string,
  invalidMessage: PropTypes.string,
  sectionName: PropTypes.string,

  children: PropTypes.node,
};

export default EmailForm;
